import Vue from 'vue';

import UtilMixins from './Util';
import LayoutMixins from './Layout';
import MomentMixins from './Moment';

Vue.mixin(UtilMixins);
Vue.mixin(LayoutMixins);
Vue.mixin(MomentMixins);



// WEBPACK FOOTER //
// ./src/mixins/index.js